import { render } from "./ApplePayButton.vue?vue&type=template&id=3ac566a4&scoped=true"
import script from "./ApplePayButton.vue?vue&type=script&lang=js"
export * from "./ApplePayButton.vue?vue&type=script&lang=js"

import "./ApplePayButton.vue?vue&type=style&index=0&id=3ac566a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac566a4"]])

export default __exports__